import { Tooltip } from "@material-ui/core";
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function UserTagPrivateBookmarkCount({ticketKnowledge}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    return (
        <div className='bookmark-count'>
            <Tooltip
                title={`${trI18n('PRIVATE_BOOKMARK_TOTAL')}`}
                placement="top"
                arrow={true}
            >
                <img src='/assets/image/icon-bookmark.svg' alt='icon-bookmark' className='knowledge-icon-frame-size'/>
            </Tooltip>
            <span className='bookmark-count-number'>
                {ticketKnowledge.totalPrivateBookmark > 0
                    ? ticketKnowledge.totalPrivateBookmark >= 100 ? '99+' : ticketKnowledge.totalPrivateBookmark
                    : '0'
                }
            </span>
        </div>
    );
}

export default UserTagPrivateBookmarkCount;